import { PartnerFinanceMonthBillIncome } from 'types/partnerFinance';
import { M8PartnerIncomeHistoryComissionItem } from '../types';
import { normalizeM8DateString } from './normalizeM8DateString';

export const normalizeM8PartnerIncomeHistoryComissionItem = (
  m8PartnerIncomeHistoryItem: M8PartnerIncomeHistoryComissionItem
) => {
  const {
    id,
    amount,
    paymentDate,
    periodStartsOn,
    periodEndsOn,
    organization,
  } = m8PartnerIncomeHistoryItem;

  const paymentDateISO = normalizeM8DateString(paymentDate)
    .toDate()
    .toISOString();

  const periodStartDateISO = normalizeM8DateString(periodStartsOn)
    .toDate()
    .toISOString();

  const periodEndDateISO = normalizeM8DateString(periodEndsOn)
    .toDate()
    .toISOString();

  return {
    toPartnerFinanceMonthBillIncome(): PartnerFinanceMonthBillIncome {
      return {
        type: 'BILL_INCOME',
        clientId: id,
        amount: amount,
        dateISO: paymentDateISO,
        periodEndDateISO,
        periodStartDateISO,
        organization,
      };
    },
  };
};
